export default __webpack_public_path__ + "static/media/home-repair.63e2a0a5.png";